import { apiRequest } from "./apiService";

const buildQueryString = (params) => {
  const entries = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== ""
  );
  if (entries.length === 0) return "";

  const query = entries
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join("&");

  return `?${query}`;
};

/**
 * GET /slug-lookup?q=...&type=city|niche|both
 * Returns: { query, cities: [...], niches: [...] }
 */
export const slugLookup = ({ q, type = "both" }) => {
  const qs = buildQueryString({ q, type });
  return apiRequest(`/slug-lookup${qs}`, "GET");
};
